module.exports = __webpack_public_path__ + "static/garlic-bdb27e55e21c7532ec0fb168ed2cf5cc.png";